"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _Select = _interopRequireDefault(require("@material-ui/core/Select"));

var _OutlinedInput = _interopRequireDefault(require("@material-ui/core/OutlinedInput"));

var _styles = require("@material-ui/core/styles");

var _Location = _interopRequireDefault(require("./icons/Location"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _Dropdown = _interopRequireDefault(require("./Dropdown.css"));

var _utils = require("../../utils");

var Dropdown =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(Dropdown, _React$PureComponent);

  function Dropdown() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Dropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Dropdown)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderValue", function (items, value, iconName, rounded, disabled, iconClass) {
      var item; // Searching selected item

      if ((0, _utils.isObject)(items[0])) {
        item = items.find(function (localItem) {
          return localItem.value === value;
        }) || {};
      } else {
        item = items[value] || {};
      }

      var label = (0, _utils.isTextContent)(item) ? item : item.label || '';

      switch (iconName) {
        case 'location':
          return React.createElement("div", {
            style: {
              display: 'flex'
            }
          }, React.createElement(_Location.default, {
            className: (0, _clsx.default)(iconClass, disabled && 'disabled')
          }), React.createElement("span", {
            style: {
              marginLeft: '13px',
              paddingTop: '1px'
            }
          }, React.createElement(_Typography.default, {
            variant: "dropdown",
            className: (0, _clsx.default)(rounded ? 'rounded' : 'squared', disabled && 'disabled')
          }, label)));

        default:
          return React.createElement(_Typography.default, {
            variant: "dropdown",
            className: (0, _clsx.default)(rounded ? 'rounded' : 'squared', disabled && 'disabled')
          }, label);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderMenuItem", function (item, index) {
      var classes = _this.props.classes;
      var value = (0, _utils.isTextContent)(item) ? index : item.value || index;
      var label = (0, _utils.isTextContent)(item) ? item : item.label || item;
      return React.createElement(_MenuItem.default, {
        key: value,
        value: value
      }, React.createElement(_Typography.default, {
        component: "div",
        variant: "inherit",
        className: classes.menuItem,
        noWrap: true
      }, label));
    });
    return _this;
  }

  (0, _createClass2.default)(Dropdown, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          disabled = _this$props.disabled,
          fullWidth = _this$props.fullWidth,
          icon = _this$props.icon,
          id = _this$props.id,
          items = _this$props.items,
          name = _this$props.name,
          label = _this$props.label,
          onChange = _this$props.onChange,
          outline = _this$props.outline,
          rounded = _this$props.rounded,
          value = _this$props.value;
      return React.createElement(_FormControl.default, {
        fullWidth: fullWidth
      }, label && React.createElement(_InputLabel.default, {
        className: classes.inputLabel,
        disableAnimation: true,
        disabled: disabled,
        htmlFor: "uh-input"
      }, React.createElement(_Typography.default, {
        variant: "caption",
        className: classes.inputLabelTypography
      }, label)), React.createElement(_Select.default, {
        classes: {
          icon: (0, _clsx.default)(classes.icon, rounded ? 'rounded' : 'squared', disabled && 'disabled'),
          select: classes.select
        },
        input: React.createElement(_OutlinedInput.default, {
          name: name,
          id: id,
          value: value,
          fullWidth: true,
          labelWidth: 0,
          disabled: disabled,
          classes: {
            notchedOutline: (0, _clsx.default)(classes.notchedOutline, rounded ? 'rounded' : 'squared', outline && 'outline', disabled && 'disabled'),
            input: (0, _clsx.default)(classes.input, rounded ? 'rounded' : 'squared'),
            root: (0, _clsx.default)(classes.outlinedInputRoot, label && 'label')
          }
        }),
        MenuProps: {
          MenuListProps: {
            classes: {
              root: (0, _clsx.default)(classes.list, rounded ? 'rounded' : 'squared')
            }
          }
        },
        onChange: onChange,
        renderValue: function renderValue(value) {
          return _this2.renderValue(items, value, icon, rounded, disabled, classes.icon);
        },
        value: value
      }, items.map(this.renderMenuItem)));
    }
  }]);
  return Dropdown;
}(React.PureComponent);

Dropdown.defaultProps = {
  disabled: false,
  fullWidth: false,

  /**
   * It is debateable whether a default Dropdown for us should
   * really be rounded or not.
   */
  onChange: function onChange() {},
  outline: true,
  rounded: false
};
Dropdown.propTypes = {
  /**
   * Whether the dropdown is disabled or not.
   * Defaults to false.
   */
  disabled: PropTypes.bool,

  /**
   * Whether the Dropdown is full width or not.
   * Defaults to false.
   */
  fullWidth: PropTypes.bool,

  /**
   * A string that adds an icon on the left of the Dropdown,
   * before its text.
   * The string gets translated into a real icon.
   */
  icon: PropTypes.oneOf(['location']),

  /**
   * The id field attached to the select input.
   */
  id: PropTypes.string,

  /**
   * The list of item to show in the menu
   */
  items: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
    /**
     * Value of the item
     */
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

    /**
     * Label of the item
     */
    label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired
  })), PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.element, PropTypes.string]))]).isRequired,

  /**
   * The name field attached to the select input.
   */
  name: PropTypes.string,

  /**
   * The label of this dropdown.
   */
  label: PropTypes.string,

  /**
   * Callback on changing value
   */
  onChange: PropTypes.func,

  /**
   * Whether the dropdown has an outline or not.
   * Defaults to true.
   */
  outline: PropTypes.bool,

  /**
   * Whether the dropdown is rounded or not.
   * Defaults to false.
   */
  rounded: PropTypes.bool,

  /**
   * The value field attached to the select input.
   */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};

var _default = (0, _styles.withStyles)(_Dropdown.default)(Dropdown);

exports.default = _default;